export default __webpack_public_path__ + "static/media/twitter.df8df59b.svg";